var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { X } from 'phosphor-react';
import { theme } from '../../styles/theme';
import { useMediaQuery } from 'react-responsive';
import * as Styled from './Dialog.styles';
export const Dialog = (_a) => {
    var { header, body, footer, headerID, bodyID, onClose } = _a, props = __rest(_a, ["header", "body", "footer", "headerID", "bodyID", "onClose"]);
    const isDesktop = useMediaQuery({
        query: theme.mq.tabletPortraitUp,
    });
    return (React.createElement(Styled.Wrapper, Object.assign({ "aria-labelledby": headerID, "aria-describedby": bodyID, sx: {
            '& .MuiDialog-container': {
                '& .MuiPaper-root': {
                    minWidth: isDesktop ? '450px' : null,
                },
            },
        } }, props),
        React.createElement(Styled.Header, null,
            React.createElement(Styled.Title, { id: headerID }, header),
            onClose ? (React.createElement(Styled.Close, { "aria-label": "close", onClick: onClose },
                React.createElement(X, { size: 24 }))) : null),
        React.createElement(Styled.Body, { id: bodyID }, body),
        footer && React.createElement(Styled.Footer, null, footer)));
};
